const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://api.fineexchange.io/v1/'
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.fineexchange.io/'

export {
    BASE_URL,
    SOCKET_URL
}

